import { Collections, Incident } from "api";
import cloneDeep from "lodash/cloneDeep";
import { useSelector } from "react-redux";
import { useFirestoreConnect } from "react-redux-firebase";
import { RootState } from "redux/model";

export const useIncidents = (raceControlId?: string): Incident[] => {
    useFirestoreConnect({
        collection: Collections.RACES_CONTROL,
        doc: raceControlId || "-1",
        subcollections: [{ collection: Collections.INCIDENTS }],
        storeAs: `incidents${raceControlId}`,
    });

    return cloneDeep(
        useSelector((state: RootState) => {
            return state.firestore.ordered[`incidents${raceControlId}`];
        }) || []
    ).sort((i1, i2) => i1.lap - i2.lap);
};
